import { QuestData, questsBackend } from "@/services/questsBackend";

export const handleExternalLinkClick =
  (quest: QuestData, callback?: (quest: QuestData) => void) =>
  (e: React.MouseEvent<HTMLDivElement | HTMLImageElement>) => {
    e.stopPropagation();

    if (!quest.url) return;

    const tg = window.Telegram?.WebApp;
    const origin = window.location.origin;

    let link = quest.url;
    let isInternal = false;

    questsBackend
      .getClickCallback(quest.id)
      .then(() => {
        if (callback) {
          callback(quest)
        }
      })
      .catch(console.error);

    // Absolute link
    if (link.startsWith(origin)) {
      link = link.replace(origin, "");
      isInternal = true;
    }

    // Relative internal link
    if (link.startsWith("/")) {
      isInternal = true;
    }

    // "collection/123" → "/collection/123"
    if (isInternal && !link.startsWith("/")) {
      link = "/" + link;
    }
    console.log("Link to go:", link, isInternal);
    // Telegram Mini App
    if (tg && tg.initData) {
      if (isInternal) {
        // 👉 save mini app
        window.location.href = link;
      } else {
        // 👉 external link in browser
        tg.openLink(link, { try_instant_view: true });
      }
      return;
    }

    // Usual link
    window.open(isInternal ? link : quest.url, "_blank", "noopener,noreferrer");
  };
